module.exports = __webpack_public_path__ + "static/media/21@2x.26973807.png";